"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MetaSyncProcessor", {
    enumerable: true,
    get: function() {
        return MetaSyncProcessor;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _metadiffsservice = require("~/services/meta-diffs.service");
const _jobslogservice = require("~/modules/jobs/jobs/jobs-log.service");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let MetaSyncProcessor = class MetaSyncProcessor {
    async job(job) {
        this.debugLog(`job started for ${job.id}`);
        const info = job.data;
        const context = info.context;
        const baseId = context.base_id;
        const logBasic = (log)=>{
            this.jobsLogService.sendLog(job, {
                message: log
            });
            this.debugLog(log);
        };
        if (info.sourceId === 'all') {
            await this.metaDiffsService.metaDiffSync(context, {
                baseId: baseId,
                logger: logBasic,
                req: info.req
            });
        } else {
            await this.metaDiffsService.baseMetaDiffSync(context, {
                baseId: baseId,
                sourceId: info.sourceId,
                logger: logBasic,
                req: info.req
            });
        }
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'source_meta_sync',
                payload: {
                    base_id: baseId,
                    source_id: info.sourceId
                }
            }
        }, context.socket_id);
        this.debugLog(`job completed for ${job.id}`);
    }
    async metaDiffJob(job) {
        this.debugLog(`job started for ${job.id}`);
        const info = job.data;
        const context = info.context;
        const baseId = context.base_id;
        let result = null;
        if (info.sourceId === 'all') {
            result = await this.metaDiffsService.metaDiff(context, {
                baseId
            });
        } else {
            result = await this.metaDiffsService.baseMetaDiff(context, {
                sourceId: info.sourceId,
                baseId,
                user: info.req.user
            });
        }
        this.debugLog(`job completed for ${job.id}`);
        return result;
    }
    constructor(metaDiffsService, jobsLogService){
        this.metaDiffsService = metaDiffsService;
        this.jobsLogService = jobsLogService;
        this.debugLog = (0, _debug.default)('nc:jobs:meta-sync');
    }
};
MetaSyncProcessor = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _metadiffsservice.MetaDiffsService === "undefined" ? Object : _metadiffsservice.MetaDiffsService,
        typeof _jobslogservice.JobsLogService === "undefined" ? Object : _jobslogservice.JobsLogService
    ])
], MetaSyncProcessor);
